import { render, staticRenderFns } from "./DBCapital.vue?vue&type=template&id=2ee76032&scoped=true&"
import script from "./DBCapital.vue?vue&type=script&lang=js&"
export * from "./DBCapital.vue?vue&type=script&lang=js&"
import style0 from "./DBCapital.vue?vue&type=style&index=0&id=2ee76032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee76032",
  null
  
)

export default component.exports